// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"ContentfulInlineTable_tableWrapper__65cyH","tableTitle":"ContentfulInlineTable_tableTitle__tyJY2","tableCitation":"ContentfulInlineTable_tableCitation__jS6Cw"};